var React = require('react');

function IconSearch (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M605.3 92.6C558.4 73.6 508.9 64 458.2 64s-100.3 9.6-147.1 28.6c-48.5 19.7-92.1 48.6-129.4 85.9s-66.2 80.8-85.9 129.4c-19 46.9-28.6 96.4-28.6 147.1s9.6 100.3 28.6 147.1c19.7 48.5 48.6 92.1 85.9 129.4 37.3 37.3 80.8 66.2 129.4 85.9 46.9 19 96.4 28.6 147.1 28.6s100.3-9.6 147.1-28.6c36.3-14.7 69.8-34.6 99.9-59.3l194.3 194.3c3.9 3.9 10.2 3.9 14.1 0l42-42c3.9-3.9 3.9-10.2 0-14.1L761.3 702.1c24.7-30.2 44.6-63.7 59.3-99.9 19-46.9 28.6-96.4 28.6-147.1s-9.6-100.3-28.6-147.1c-19.7-48.5-48.6-92.1-85.9-129.4s-80.8-66.3-129.4-86zM769.9 455c0 83.3-32.4 161.6-91.3 220.4-58.9 58.9-137.2 91.3-220.4 91.3-83.3 0-161.6-32.4-220.4-91.3-58.9-58.9-91.3-137.2-91.3-220.4s32.4-161.6 91.3-220.4c58.9-58.9 137.2-91.3 220.4-91.3s161.6 32.4 220.4 91.3c58.9 58.8 91.3 137.1 91.3 220.4z"}));
}

IconSearch.displayName = "IconSearch";

IconSearch.defaultProps = {"viewBox":"0 0 1024 1024"};

module.exports = IconSearch;

IconSearch.default = IconSearch;
